import React, { useContext } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import FlashNotificationContext from './FlashNotificationContext';

const FlashNotificationContainer = () => {
  const context = useContext(FlashNotificationContext);

  if (!context) return null;

  const { hideFlashNotification, notification } = context;

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={6000}
      key={notification ? notification.id : 'empty'}
      onClose={hideFlashNotification}
      open={Boolean(notification)}
    >
      {notification ? (
        <Alert
          elevation={6}
          onClose={hideFlashNotification}
          role="alert"
          severity={notification.severity}
          variant="filled"
        >
          {notification.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};

export default FlashNotificationContainer;
